export class ActivityModel {
  public id: number;
  public nombre: string;

  constructor();
  constructor(id: number);
  constructor(id: number, nombre: string);
  constructor(id?: number, nombre?: string) {
    switch (arguments.length) {
      case 1:
        this.id = id;
        break;
      case 2:
        this.id = id;
        this.nombre = nombre;
        break;
      default:
        this.id = 0;
        this.nombre = '';
        break;
    }
  }
}
